/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcelTrackingVo
 */
export interface ParcelTrackingVo {
    /**
     * 运单号
     * @type {string}
     * @memberof ParcelTrackingVo
     */
    trackingNo?: string;
    /**
     * 运单状态名称
     * @type {string}
     * @memberof ParcelTrackingVo
     */
    parcelStatusName?: string;
    /**
     * 运单状态
     * @type {number}
     * @memberof ParcelTrackingVo
     */
    parcelStatus?: number;
    /**
     * 最初的代买商品ID
     * @type {number}
     * @memberof ParcelTrackingVo
     */
    proxyBuyPreGoodsId?: number;
    /**
     * 无数据编号（快递已关联 nodata 时有值）
     * @type {number}
     * @memberof ParcelTrackingVo
     */
    nodataId?: number;
}

/**
 * Check if a given object implements the ParcelTrackingVo interface.
 */
export function instanceOfParcelTrackingVo(value: object): value is ParcelTrackingVo {
    return true;
}

export function ParcelTrackingVoFromJSON(json: any): ParcelTrackingVo {
    return ParcelTrackingVoFromJSONTyped(json, false);
}

export function ParcelTrackingVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcelTrackingVo {
    if (json == null) {
        return json;
    }
    return {
        
        'trackingNo': json['trackingNo'] == null ? undefined : json['trackingNo'],
        'parcelStatusName': json['parcelStatusName'] == null ? undefined : json['parcelStatusName'],
        'parcelStatus': json['parcelStatus'] == null ? undefined : json['parcelStatus'],
        'proxyBuyPreGoodsId': json['proxyBuyPreGoodsId'] == null ? undefined : json['proxyBuyPreGoodsId'],
        'nodataId': json['nodataId'] == null ? undefined : json['nodataId'],
    };
}

export function ParcelTrackingVoToJSON(json: any): ParcelTrackingVo {
    return ParcelTrackingVoToJSONTyped(json, false);
}

export function ParcelTrackingVoToJSONTyped(value?: ParcelTrackingVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackingNo': value['trackingNo'],
        'parcelStatusName': value['parcelStatusName'],
        'parcelStatus': value['parcelStatus'],
        'proxyBuyPreGoodsId': value['proxyBuyPreGoodsId'],
        'nodataId': value['nodataId'],
    };
}

